import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const Title = styled.h2`
  text-align: center;
  font-size: 18px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f2f2f2;
`;

export const Content = styled.div`
  flex: 1;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background-color: white;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

  /* display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background-color: white;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
`;

export const CustomButton = styled(Button)`
  /* background-color: #6200ea; */
  color: 'primary';
  padding: 10px 20px;
  font-size: 16px;

  &:hover {
    background-color: #3700b3;
  }
`;

// export const Button = styled.button`
//   padding: 15px;
//   border: none;
//   border-radius: 8px;
//   background-color:rgb(104, 130, 168);
//   color: white;
//   font-size: 16px;
//   cursor: pointer;
//   transition: background-color 0.3s;

//   &:hover {
//     background-color:rgb(87, 116, 160);
//   }
// `;

export const PreviewContainer = styled.div`
  margin-top: 15px;
  text-align: center;
  overflow-y: auto;
  height: 600px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  max-width: 360px;
  margin-bottom: 10px;
`;

export const Video = styled.video`
  /* width: 680px; */
  height: 450px;
  /* max-width:  360px; */
  max-height: 450px;

  background: #000;
  display: block;
  margin: 0 auto;
`;

export const ProgressContainer = styled.div`
  margin-top: 15px;
  text-align: center;
`;

export const ProgressBar = styled.progress`
  width: 100%;
  max-width: 360px;
`;

export const ContainerCabecalho = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
  background-color: #f5f5f5;
  padding: 6px;
  gap: 1.5px;
`;

// Card da nota fiscal
export const NotaFiscalContainerCabecalho = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
`;

// Título do card
export const HeaderCabecalho = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 5px;
  color: #333;
  text-align: center;
`;

export const TableCabecalho = styled.table`
  width: 98%;
  border-collapse: separate;
  border-spacing: 1;
  /* background-color:rgb(247, 247, 248); */
  background-color: #f2f2f2;

  font-size: 1rem; /* Reduz um pouco o tamanho da fonte */
  margin-bottom: 2px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden; /* Mantém os cantos arredondados */

  /* Ajusta a altura das linhas */
  th,
  td {
    /* padding: 8px 12px; Reduz a altura */
    height: 2px; /* Define uma altura menor para as linhas */
  }

  /* Garante que os cantos superiores fiquem arredondados */
  thead tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }
  thead tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }

  /* Garante que os cantos inferiores fiquem arredondados */
  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }
  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
`;

export const TdCabecalho = styled.td`
  padding-left: 3px;
  /* color: #333; */
  color: rgba(255, 254, 254, 0.92);
  border-bottom: 1px solid black; /* Apenas borda inferior para visual mais limpo */
  &:first-child {
    padding-left: 12px;
    border-bottom-left-radius: 10px; /* Arredonda o canto inferior esquerdo */
  }
  &:last-child {
    border-bottom-right-radius: 10px; /* Arredonda o canto inferior direito */
  }
`;

export const TrCabecalho = styled.tr`
  background-color: rgba(45, 123, 240, 0.52);
  /* background-color:rgb(192, 211, 240); */
  color: rgba(32, 32, 32, 0.53);
  /* background-color: #f5f5f5; Suaviza a linha de cabeçalho */
  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const ThCabecalho = styled.th`
  text-align: left;
  font-weight: bold;
  padding: 1px; /* Aumentado um pouco para melhor espaçamento */
  background-color: rgba(219, 208, 208, 0.84);
  /* border-bottom: 2px solid black; Deixa apenas uma borda inferior para separar melhor */
  width: 35%;
  &:first-child {
    padding-left: 12px; /* Deixa mais espaço no primeiro elemento */
    border-top-left-radius: 10px; /* Arredonda o canto superior esquerdo */
  }
  &:last-child {
    border-top-right-radius: 10px; /* Arredonda o canto superior direito */
  }
`;
// rgb(63,81,181)
// rgb(139,180,241)

// Tabela estilizada
// export const TableCabecalho = styled.table`
//     width: 98%;
//     border-collapse: collapse;
//     background-color:rgb(215, 220, 227);
//     /* border: 1px solid black; */
//     font-size: 1.1rem;
//     margin-bottom: 2px;
//     box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
// `;

// export const TableCabecalho = styled.table`
//     width: 98%;
//     border-collapse: separate; /* Alterado de collapse para separate */
//     border-spacing: 0; /* Remove espaçamentos entre células */
//     background-color: rgb(215, 220, 227);
//     font-size: 1.1rem;
//     margin-bottom: 2px;
//     box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
//     border-radius: 10px;
//     overflow: hidden; /* Garante que as bordas arredondadas sejam aplicadas */
// `;

// export const ThCabecalho = styled.th`
//     text-align: left;
//     font-weight: bold;
//     padding-left: 4px;
//     background-color:rgba(219, 208, 208, 0.84);
//     border: 1px solid black;
//     width: 35%;
// `;

// export const TdCabecalho = styled.td`
//     padding: 4px;
//     color: #333;
//     border: 1px solid black;
// `;

// export const TrCabecalho = styled.tr`
//    border: 1px solid black;
// `;
